import { CommonModule, NgOptimizedImage } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { LoaderService } from '../../services/loader/loader-service';

@Component({
    selector: 'pims-loader',
    imports: [CommonModule, NgOptimizedImage],
    templateUrl: './loader.component.html',
    styleUrl: './loader.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LoaderComponent {
    readonly loader = inject(LoaderService);
}
